import { render, staticRenderFns } from "./MarketingSpendDetail.vue?vue&type=template&id=45cd6e8e&"
import script from "./MarketingSpendDetail.vue?vue&type=script&lang=js&"
export * from "./MarketingSpendDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports